import { ptBR } from 'date-fns/locale';
import { format } from 'date-fns';

export function formatDate(date: Date, withHours = true): string {
  return format(date, `dd/MM/yyyy${withHours ? ' HH:mm' : ''}`, {
    locale: ptBR,
  });
}
